var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3164,
    cy: 10,
    r: 9.75,
    fill: "#EFE9FE",
    stroke: "#8F38EF",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_2994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0664 12.7099C12.6547 12.7099 12.2864 12.8724 12.0047 13.127L8.14266 10.8791C8.16974 10.7545 8.19141 10.6299 8.19141 10.4999C8.19141 10.3699 8.16974 10.2453 8.14266 10.1208L11.9614 7.8945C12.2539 8.16534 12.6385 8.33325 13.0664 8.33325C13.9656 8.33325 14.6914 7.60742 14.6914 6.70825C14.6914 5.80909 13.9656 5.08325 13.0664 5.08325C12.1672 5.08325 11.4414 5.80909 11.4414 6.70825C11.4414 6.83825 11.4631 6.96284 11.4902 7.08742L7.67141 9.31367C7.37891 9.04284 6.99432 8.87492 6.56641 8.87492C5.66724 8.87492 4.94141 9.60075 4.94141 10.4999C4.94141 11.3991 5.66724 12.1249 6.56641 12.1249C6.99432 12.1249 7.37891 11.957 7.67141 11.6862L11.5281 13.9395C11.501 14.0533 11.4847 14.1724 11.4847 14.2916C11.4847 15.1637 12.1943 15.8733 13.0664 15.8733C13.9385 15.8733 14.6481 15.1637 14.6481 14.2916C14.6481 13.4195 13.9385 12.7099 13.0664 12.7099Z",
    fill: "#8F38EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_2994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(3.31641 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationShare);
export default __webpack_public_path__ + "static/media/notification_share.9c0433ea0c88f43221d2dedd8a61441d.svg";
export { ForwardRef as ReactComponent };